import { selectFavoriteProfiles } from '@/store/lists/selectors/selectFavoriteProfiles';
import { selectReaderProfiles } from '@/store/lists/selectors/selectReaderProfiles';
import { selectProfiles } from '@/store/user/selectors/selectProfiles';
import { useSelector } from 'react-redux';
import UserProfilesSelector from './UserProfilesSelector';

function UserProfilesSelectorContainer({
  containerClassName,
  onChange,
  value,
  menuPortalTarget,
  isMulti,
  isClearable,
  className,
  placeholder,
  isDisabled
}) {
  const favorites = useSelector(selectFavoriteProfiles);
  const readers = useSelector(selectReaderProfiles);
  const owned = Object.values(useSelector(selectProfiles));

  return (
    <div className={containerClassName}>
      <UserProfilesSelector
        favorites={favorites}
        readers={readers}
        owned={owned}
        onChange={onChange}
        value={value}
        menuPortalTarget={menuPortalTarget}
        isMulti={isMulti}
        isClearable={isClearable}
        className={className}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
    </div>
  );
}

export default UserProfilesSelectorContainer;
